import React from "react";
import { Field } from "react-final-form";

import {
  composeFormValidators,
  isRequired,
  isAlphaNumeric,
  isEmail,
  hasMaxLength,
  isPhoneNumber,
} from "@lib/validations";

import InputText from "@components/Form/InputText";

const UserFields = () => (
  <>
    {/* Full name */}
    <div className="pb-4">
      <Field
        component={InputText}
        id="contact_full_name"
        name="Name"
        label="Nume Prenume"
        required
        validate={composeFormValidators(
          isRequired(),
          isAlphaNumeric(),
          hasMaxLength(60)
        )}
      />
    </div>

    {/* Phone */}
    <div className="pb-4">
      <Field
        component={InputText}
        id="contact_phone"
        name="Phone"
        label="Telefon"
        type="tel"
        validate={isPhoneNumber()}
      />
    </div>

    {/* Email */}
    <div className="pb-4">
      <Field
        component={InputText}
        id="contact_email"
        name="Email"
        label="Introdu adresa de email"
        type="email"
        required
        validate={composeFormValidators(
          isRequired(),
          isEmail(),
          hasMaxLength(80)
        )}
      />
    </div>
  </>
);

export default UserFields;
